export const PRIMARY = '#00837E';
export const PRIMARY_LIGHT = '#e5f7f6';
export const PRIMARY_LIGHT_SECONDARY = '#f4fafa';
export const SECONDARY = '#1e958c';
export const ORANGE = '#f49d10';
export const ORANGE_SECONDARY = '#ed7422';
export const ORANGE_LIGHT = '#faf3ee';
export const GRAY = '#cccbcb';
export const GRAY_SECONDARY = '#939393';
export const GRAY_TERTIARY = '#b2b2b2';
export const GRAY_MEDIUM = '#e1e1e1';
export const GRAY_LIGHT = '#f2f2f2';
export const GRAY_LIGHT_SECONDARY = '#efefef';
export const GRAY_LIGHT_TERTIARY = '#f7f7f7';
export const RED = '#f41710';
export const RED_LIGHT = '#fef0f0';
export const TEXT = '#023850';
export const DARK = '#023850';
export const BLUE = '#0094bf';
export const BLUE_SECONDARY = '#D2EBF0';
export const BLUE_TERTIARY = '#F1F9FB';
export const BLUE_LIGHT = '#1f9bb4';
export const BLUE_DARK = '#136f8b';
export const YELLOW = '#ffd100';
export const WHITE = '#ffffff';
export const TURQUOISE = '#21a2b9';
export const MINT = '#7ac6bc';
export const PURPLE = '#7e57c2';

// New UI Colors
export const NEW_RED_LIGHT = '#FFDAD6';
export const NEW_YELLOW_LIGHT = '#FFF1C2';
export const NEW_GREEN_LIGHT = '#CFF7D3';
export const NEW_PRIMARY_LIGHT = '#F2F9F7';
export const OUTLINE_VARIANT = '#C4C7C6';
export const ON_SURFACE_VARIANT = '#3F4948';

// Amber (concept chip)
export const AMBER = '#F5A623';
export const AMBER_DARK = '#92400E';
export const AMBER_LIGHT = '#FFFAEC';

// Muted red (urgent chip — softer than RED)
export const RED_MUTED = '#DC2626';
export const RED_MUTED_LIGHT = '#FEF2F2';

// Custom Colors
export const CUSTOM_ERROR_COLOR_LIGHT = '#fbedeb';
export const CUSTOM_WARNING_COLOR_LIGHT = '#fcf3e9';

export const rgbaPrimary = (alpha = 1) => `rgba(0,177,170,${alpha})`;
export const rgbaBlueDark = (alpha = 1) => `rgba(19,111,139,${alpha})`;
export const rgbaOrange = (alpha = 1) => `rgba(244,157,16,${alpha})`;
export const rgbaDark = (alpha = 1) => `rgba(0,0,0,${alpha})`;
export const rgbaRed = (alpha = 1) => `rgba(244,23,16,${alpha})`;
export const rgbaWhite = (alpha = 1) => `rgba(244,244,244,${alpha})`;

export const CHARCOAL = '#171D1C';
export const SLATE = '#4E5F79';
export const RED_DARK = '#861915';

// SDB UI Colors
export const MUI_PALETTE_BACKGROUND_DEFAULT = '#F2F9F8';
